module.exports = __webpack_public_path__ + "img/abou_us_1.a01d6e4c.png";